import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=e561bcc2&"
import script from "./input-date.component.ts?vue&type=script&lang=ts&"
export * from "./input-date.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports